import { MatSelectChange } from "@angular/material";
import { Component, OnInit, Inject } from "@angular/core";
//import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  MatDialog,
  MatDialogRef,
  //MatDialogRef,
  MAT_DIALOG_DATA
  //MatDialog
  // MatDialog
} from "@angular/material/dialog";

import { TranslateService } from "@ngstack/translate";
import { ErrorsService } from "src/app/services/common/errors.service";
//import * as moment from "jalali-moment";
//import { SoundEnum } from "src/app/enums/sound.enum";
//// import { IConfirm } from "src/app/interfaces/confirm";
//import { ILevelInfo } from "src/app/interfaces/levelInfo";
//import { ICourseHistory } from "src/app/interfaces/course-history";
//import { IEducationPackage } from "src/app/interfaces/educationPackage";
//import { SnackBarService } from "src/app/services/common/snackBar.service";
//import { RoomService } from "src/app/services/http/business/room/room.service";
//import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
import { TermInfoService } from "src/app/services/http/business/term-info/term-info.service";
//import { BranchService } from "src/app/services/http/business/branch/branch.service";
//import { IDiscountGroupByTermInfo } from "src/app/interfaces/discountGroup-byTermInfo";
import { CourseService } from "./../../../../services/http/business/course/course.service";
//import { LevelInfoService } from "src/app/services/http/business/levelInfo/level-info.service";
//import { StaticValueService } from "src/app/services/http/business/staticValue/static-value.service";
//import { CourseHistoryService } from "src/app/services/http/business/course-history/course-history.service";
// import { EducationPackageService } from "src/app/services/http/business/educationPackage/education-package.service";
//import { CoursePatternService } from "src/app/services/http/business/course-pattern/course-pattern.service";
//import { DiscountGroupService } from "src/app/services/http/business/discount-group/discount-group.service";
//import { IConfirm } from "src/app/interfaces/confirm";
//import { ConfirmComponent } from "src/app/components/confirm/confirm.component";
//import { ExceptionalCoefficientsService } from "src/app/services/http/business/ExceptionalCoefficients/exceptional-coefficients.service";
//import { environment } from "src/environments/environment";
//// import { PackageEducationBranchComponent } from "../../education-package/package-education-branch/package-education-branch.component";
//import { PackageEducationBranchService } from "src/app/services/http/business/packageEducationBranch/package-education-branch.service";
import { CalendarService } from "../../../../services/http/business/calendar/calendar.service";
import { ParrentTermService } from "../../../../services/http/business/parrent-term/parrent-term-service.service";
import { HttpHeaders } from "@angular/common/http";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { IConfirm } from "../../../../interfaces/confirm";
import { ConfirmComponent } from "../../../../components/confirm/confirm.component";
import { SoundEnum } from "../../../../enums/sound.enum";
import { SnackBarService } from "../../../../services/common/snackBar.service";
import { IError } from "src/app/interfaces/error.interface";


@Component({
  selector: 'app-select-term-batch-course',
  templateUrl: './select-term-batch-course.component.html',
  styleUrls: ['./select-term-batch-course.component.css'],
})
export class SelectTermBatchCourseComponent implements OnInit {

  form: FormGroup;
  yearList: any;
  parrentTermList: any;
  terminfoList: any;

  errors = new Array();
  errObject: any;
  param: any;
  errorList: IError[] = [];

  constructor(
    //private fb: FormBuilder,
    //private dialog: MatDialog,
    //private snackBar: SnackBarService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private snackbar: SnackBarService,
    private errorService: ErrorsService,
    public translate: TranslateService,
    public courseService: CourseService,
    private calendarService: CalendarService,
    private parrentTermService: ParrentTermService,
    private termInfoService: TermInfoService,
    private dialogRef: MatDialogRef<SelectTermBatchCourseComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit() {
    this.createForm();
    this.loadYear();
    this.getParrentTermList();
  }

  createForm() {
    this.form = this.fb.group({
      Year: [null, Validators.required],
      ParentTermId: [null, Validators.required],
      TermInfoId: [null, Validators.required],
    });
  }

  loadYear() {
    this.calendarService.yearList().subscribe(
      res => {
        this.yearList = res;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getParrentTermList() {
    const headers = new HttpHeaders({
      "Content-Type": "application/json"
    })
      .append("Authorization", "Bearer " + localStorage.getItem("token"))
      .append(
        "HID",
        localStorage.getItem("holdingCode")
          ? localStorage.getItem("holdingCode")
          : ""
      )
      .append(
        "CID",
        this.data.CompanyEncryptId
      );

    this.parrentTermService.listByCompanyHeader(0, 0, headers).subscribe(
      res => {
        this.parrentTermList = res.DataList;
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }

  getTerminfoList(e: MatSelectChange) {
    const query = {
      Year: this.form.value.Year,
      ParentTermId: e.value
    };
    var _data = this.data;
    this.termInfoService.list(query, 0, 0).subscribe(
      res => {
        this.terminfoList = res.DataList.filter(function(item){
          return item.CourseTypeId == _data.CourseTypeId
        });
      },
      () => {
        this.errorService.transactionError();
      }
    );
  }


  submit(form: any) {
    this.errors = new Array();
    let confirm: IConfirm = {
      accept: true,
      message: "آیا از ثبت کلاس ها در ترم جدید اطمینان دارید؟",
      alert: null,
      yesLabel: this.translate.get("label.yes"),
      noLabel: this.translate.get("label.no")
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {

        const command = {
          BranchEncryptId: this.data.BranchEncryptId,
          CoursePatternId: this.data.CoursePatternId,
          TermInfoId: this.data.TermInfoId,
          TermInfoIdNewId: form.TermInfoId
        };
        this.courseService.CourseBatchClassDefinitionInNewTearm(command).subscribe(res => {
          this.snackbar.OpenSnackBar(
            "تعداد " + res.returnValue + " کلاس در ترم جدید با موفقیت ایجاد گردید",
            "OK",
            5000,
            SoundEnum.beep
          );
        }, err => {
          // this.errObject = this.errorService.getError(err);
          // this.param = this.errorService.objectError(this.errObject);
          // this.errors = this.errorService.returnError(err);
          this.errorList = this.errorService.getErrorList(err.error);
        })
      }
    });




  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
